import { RSAA } from "redux-api-middleware";

import config from "@/utils/config";

import { CAMPAIGNS_FAILURE, CAMPAIGNS_REQUEST, CAMPAIGNS_RESET, CAMPAIGNS_SUCCESS } from "./types";

export const loadCampaigns = (vin: string) => ({
  [RSAA]: {
    endpoint: `${config.get("apiSuzuki")}recall-campaigns/${vin}/`,
    method: "GET",
    types: [CAMPAIGNS_REQUEST, CAMPAIGNS_SUCCESS, CAMPAIGNS_FAILURE],
  },
});

export const resetCampaigns = () => ({
  type: CAMPAIGNS_RESET,
});
